import { fmt, fdate } from "@/lib/api";

export const PendingCash = ({ rows, cur, testId }) => {
  if (!rows?.length) return null;
  return (
    <div className="mt-2 rounded-md border border-dashed border-amber-300 bg-amber-50/60 p-2 text-xs" data-testid={testId}>
      <div className="font-semibold text-amber-800">Waiting for approval · not counted in the balances above</div>
      <ul className="mt-1 space-y-1">{rows.map((j) => (
        <li key={j.id} data-testid={`${testId}-${j.number}`}>
          <div className="text-slate-600"><span className="font-mono">{j.number}</span> · {fdate(j.date)}{j.memo ? ` · ${j.memo}` : ""}</div>
          {j.effects.map((e) => <div key={e.code} className="flex justify-between gap-3 pl-2 text-slate-500"><span className="min-w-0">{e.code} {e.name}</span>
            <span className="whitespace-nowrap tabular-nums">{e.amount > 0 ? "+" : "−"}{fmt(Math.abs(e.amount), cur)}</span></div>)}
        </li>))}</ul>
    </div>
  );
};
